import { environment } from '../environments/environment';
import { INavData } from '@coreui/angular';

export const navItems: INavData[] = [
  environment.modules.dashboard
    ? {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'fa fa-dashboard'
    }
    : undefined,
  environment.modules.burialSocieties
    ? {
      name: 'Groups',
      icon: 'fa fa-dashboard',
      children: [
        {
          name: 'Manage Groups',
          url: '/burial-societies',
          icon: 'fa fa-dashboard',
          attributes: {
            roles: []
          }
        },
        {
          name: 'Create a Group',
          url: '/burial-societies/create',
          icon: 'icon-puzzle',
          attributes: {
            roles: []
          }
        }
      ]
    }
    : undefined,
  environment.modules.individuals
    ? {
      title: true,
      name: 'Individual Policies',
      attributes: {
        roles: []
      }
    }
    : undefined,
  environment.modules.individuals
    ? {
      name: 'Manage Policies',
      url: '/individuals',
      icon: 'fa fa-dashboard',
      attributes: {
        roles: []
      }
    }
    : undefined,
  environment.modules.individuals
    ? {
      name: 'Register Policy',
      url: '/individuals/create',
      icon: 'fa fa-user-plus',
      attributes: {
        roles: []
      }
    }
    : undefined,
  /**
    * TODO: format roles to be an array of roles in case you many roles for each navitem
   */
  // environment.modules.individuals &&
  //   environment.subModules.individuals.bulkPayments
  //   ? {
  //     name: 'Bulk Payments',
  //     url: '/individuals/bulk-payments/upload',
  //     icon: 'fa fa-cloud-upload',
  //     attributes: {
  //       roles: 'BULK_SPONSORSHIP'
  //     }
  //   }
  //   : undefined,
  environment.modules.individuals &&
    environment.subModules.individuals.bulkOperations
    ? {
      name: 'Bulk Operations',
      url: '/individuals/bulk-operations',
      icon: 'fa fa-tasks',
      attributes: {
        roles: 'BULK_OPERATIONS'
      }
    }
    : undefined,
  // environment.modules.individuals &&
  // environment.subModules.individuals.bulkPayments
  //   ? {
  //       name: 'View Bulk Payments',
  //       url: '/individuals/bulk-payments',
  //       icon: 'fa fa-list'
  //     }
  //   : undefined,
  environment.modules.individuals &&
    environment.subModules.individuals.reconciliations
    ? {
      name: 'Reconciliations',
      url: '/individuals/reconciliations',
      icon: 'fa fa-handshake-o',
      attributes: {
        roles: []
      }
    }
    : undefined,
  environment.modules.individuals &&
    environment.subModules.individuals.bulkDependants
    ? {
      name: 'Bulk Dependants',
      url: '/individuals/bulk-dependants/upload',
      icon: 'fa fa-cloud-upload',
      attributes: {
        roles: []
      }
    }
    : undefined,
  environment.modules.individuals &&
    environment.subModules.individuals.bulkPolicyHolders
    ? {
      name: 'Bulk Policy Holders',
      url: '/individuals/bulk-policy-holders/upload',
      icon: 'fa fa-cloud-upload',
      attributes: {
        roles: []
      }
    }
    : undefined,
  environment.modules.payments
    ? {
      title: true,
      name: 'View Payments',
      attributes: {
        roles: []
      }
    }
    : undefined,
  environment.modules.payments
    ? {
      name: 'Payments',
      url: '/payments',
      icon: 'icon-list',
      attributes: {
        roles: []
      }
    }
    : undefined,
  environment.modules.packagesAndAddOns
    ? {
      title: true,
      name: 'Packages & AddOns',
      attributes: {
        roles: []
      }
    }
    : undefined,
  environment.modules.packagesAndAddOns
    ? {
      name: 'Packages & AddOns',
      icon: 'icon-puzzle',
      children: [
        {
          name: 'Manage Packages',
          url: '/burial-societies/packages',
          icon: 'icon-puzzle',
          attributes: {
            roles: []
          }
        },
        {
          name: 'Create Package',
          url: '/burial-societies/packages/create',
          icon: 'icon-puzzle',
          attributes: {
            roles: []
          }
        },
        {
          name: 'Create Addon',
          url: '/burial-societies/packages/addon',
          icon: 'icon-puzzle',
          attributes: {
            roles: []
          }
        }
      ]
    }
    : undefined,
  environment.modules.claims
    ? {
      title: true,
      name: 'Claims'
    }
    : undefined,
  environment.modules.claims
    ? {
      name: 'Claims',
      icon: 'fa fa-dashboard',
      children: [
        {
          name: 'Manage Claim Requests',
          url: '/claim-requests',
          icon: 'fa fa-plus',
          attributes: {
            roles: []
          }
        },
        {
          name: 'Process Claims',
          url: '/claims/processing',
          icon: 'fa fa-pencil-square-o',
          attributes: {
            roles: []
          }
        }
      ]
    }
    : undefined,
  environment.modules.search
    ? {
      name: 'Search',
      url: '/burial-societies/search',
      icon: 'fa fa-search',
      attributes: {
        roles: []
      }
    }
    : undefined,
    environment.modules.commissions
    ? {
      title: true,
      name: 'Commissions',
      attributes: {
        roles: []
      }
    }
    : undefined,
  environment.modules.commissions
    ? {
      name: 'Manage Commissions',
      url: '/commissions',
      icon: 'fa fa-dashboard',
      attributes: {
        roles: []
      },
      children: [
        {
          name: 'My Commissions',
          url: '/commissions',
          icon: 'fa fa-dashboard',
          attributes: {
            roles: []
          }
        },
        {
          name: 'My Registrations',
          url: '/commissions/my-registrations',
          icon: 'fa fa-dashboard',
          attributes: {
            roles: []
          }
        },
        {
          name: 'Agent Commissions',
          url: '/commissions/agent-commissions',
          icon: 'icon-star',
          attributes: {
            roles: []
          },
        },
        {
            name: 'Agent Registrations',
            url: '/commissions/agent-registrations',
            icon: 'fa fa-users',
            attributes: {
              roles: []
            }
        },
        {
          name: 'Commissions Report',
          url: '/commissions/commissions-report',
          icon: 'fa fa-address-book',
          attributes: {
            roles: []
          }
      },
      ]

    }
    : undefined,
].filter(nav => !!nav);
